var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconBookmarkPurple = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 23,
  viewBox: "0 0 18 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_6378_11366)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.5 22.5C16.214 22.5 15.928 22.39 15.719 22.181L8.8 15.262L1.881 22.181C1.562 22.5 1.089 22.588 0.682 22.423C0.275 22.258 0 21.851 0 21.411V3.8C0 1.985 1.485 0.5 3.3 0.5H14.3C16.115 0.5 17.6 1.985 17.6 3.8V21.4C17.6 21.84 17.336 22.247 16.918 22.412C16.786 22.467 16.643 22.5 16.5 22.5ZM8.8 12.6C9.086 12.6 9.361 12.71 9.581 12.919L15.4 18.738V3.8C15.4 3.195 14.905 2.7 14.3 2.7H3.3C2.695 2.7 2.2 3.195 2.2 3.8V18.749L8.019 12.93C8.239 12.71 8.514 12.611 8.8 12.611V12.6Z",
  fill: "#1160FF"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_6378_11366"
}, /*#__PURE__*/React.createElement("rect", {
  width: 17.6,
  height: 22,
  fill: "white",
  transform: "translate(0 0.5)"
})))));
export default SvgIconBookmarkPurple;